import { Image, type ImageProps } from '@mantine/core';
import styles from './CoinIcon.module.css';

export type CoinIconProps = ImageProps & {
  withAnimation?: boolean;
  'data-test-id'?: string;
};

export const CoinIcon = ({
  withAnimation = true,
  w = 32,
  h = 32,
  'data-test-id': dataTestId,
  ...props
}: CoinIconProps) => {
  return (
    <Image
      alt="coin"
      className={styles['coin-icon']}
      data-animated={withAnimation}
      data-test-id={dataTestId}
      fit="contain"
      h={h}
      src="/icons/coin.webp"
      style={{
        userSelect: 'none',
      }}
      w={w}
      {...props}
    />
  );
};
